module.exports = __webpack_public_path__ + "media/images/iconSquadBet__tieBreaker-c7aba65cc57322a0bf0985ae814b70db.png";